/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('vsk:variant:changed', function(event) {
    const data = event.detail;
    variantInfo = JSON.parse(data.variantInformation);

    const priceContainer = $(document).find('[data-id="'+ data.productID +'"] .product-item__price-list');

    if (priceContainer) {
        priceContainer.html(buildPrice(variantInfo));
    }
});

// Function to update exclusive badges
function updateExclusiveBadges() {
    const variantScript = document.querySelector('script[data-variant]');
    
    if (!variantScript) return;
    
    let currentVariant;
    try {
        currentVariant = JSON.parse(variantScript.textContent);
    } catch (e) {
        console.error('Error parsing current variant:', e);
        return;
    }
    
    // Get variant metafields data from script tag
    const metafieldsScript = document.querySelector('script[data-variant-metafields]') || document.querySelector('script[data-variant-metafields-gallery]');
    let variantMetafields = {};
    
    if (metafieldsScript) {
        try {
            variantMetafields = JSON.parse(metafieldsScript.textContent);
        } catch (e) {
            console.error('Error parsing variant metafields:', e);
            return;
        }
    }
    
    // Update exclusive badge visibility based on variant metafield
    const exclusiveBadges = document.querySelectorAll('.product-gallery__exclusive-badge');
    
    exclusiveBadges.forEach(function(badge) {
        let isExclusive = false;
        
        if (currentVariant && currentVariant.id && variantMetafields[currentVariant.id]) {
            const metafield = variantMetafields[currentVariant.id].variant_exclusive;
            isExclusive = metafield === true;
        }
        
        if (isExclusive) {
            badge.style.display = 'block';
        } else {
            badge.style.display = 'none';
        }
    });

    // NEWバッチ表示
    // Update new badge visibility based on variant metafield
    const newBadges = document.querySelectorAll('.product-gallery__new-badge');

    newBadges.forEach(function(badge) {
        let isNewBadge = false;

        if (currentVariant && currentVariant.id && variantMetafields[currentVariant.id]) {
            const metafield = variantMetafields[currentVariant.id].variant_new_badge;
            isNewBadge = metafield === true;
        }

        if (isNewBadge) {
            badge.style.display = 'block';
        } else {
            badge.style.display = 'none';
        }
    });

}

document.addEventListener('variant:changed', function(event) {
    // Small delay to ensure the variant script is updated
    setTimeout(updateExclusiveBadges, 50);
});

// Also listen for product:rerender to update badges after re-rendering
document.addEventListener('product:rerender', function(event) {
    // Delay to ensure DOM is updated after re-render
    setTimeout(updateExclusiveBadges, 100);
});
function buildPrice(data) {
    var priceHtml = '<div>';
    let compareAtPrice = data.compareAtPrice ? data.compareAtPrice.amount : 0;
    let price =  data.price.amount;

    if (compareAtPrice > price) {
        let discount_percentage = calculateDiscountPercentage(compareAtPrice, price);
        priceHtml += `
            <span class="price price--highlight">${formatMoney(price)}</span>
            <span class="price price--compare">${formatMoney(compareAtPrice)}</span>
            <span class="price--divider">/</span>
            <span class="price--discount-badge">${discount_percentage}% OFF</span>
        `;
    } else {
        priceHtml += `<span class="price">${formatMoney(price)}</span>`;
    }

    priceHtml += '</div>';
    return priceHtml;
}
function calculateDiscountPercentage(comparePrice, currentPrice) {
    comparePrice = parseFloat(comparePrice);
    currentPrice = parseFloat(currentPrice);

    if (!comparePrice || comparePrice <= 0 || !currentPrice || currentPrice <= 0) {
        return 0;
    }

    const discount = ((comparePrice - currentPrice) * 100) / comparePrice;

    return Math.round(discount);
}

function formatMoney(amount) {
    if (!amount) return "¥0";

    const number = parseFloat(amount);

    return new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: 'JPY',
        maximumFractionDigits: 0
    }).format(number);
}






// パスワード表示/非表示切り替え
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.c_password-toggle');
  if (!btn) return;

  const wrapper = btn.closest('.c_password-wrapper');
  const input = wrapper.querySelector('input');

  if (input.type === 'password') {
    input.type = 'text';
    btn.classList.add('is-visible');
  } else {
    input.type = 'password';
    btn.classList.remove('is-visible');
  }
});


// 会員登録ページのパスワード表示/非表示切り替え（Helium対応 / SVGアイコン版）
(function () {
  const DONE = 'data-pw-toggle-ready';

  // （表示）アイコン
  const ICON_EYE = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" focusable="false">
      <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
    </svg>
  `;

  // （非表示）アイコン
  const ICON_EYE_OFF = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" focusable="false">
      <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
    </svg>
  `;

  function setupHeliumPasswordField(root = document) {
    // Heliumのinputを特定
    // const inputs = root.querySelectorAll(
    //   'input[data-cf-input][data-cf-column-key="password"], input[data-cf-input][name="password"]'
    // );

    // password + password_confirmation
    const inputs = root.querySelectorAll(`
      input[data-cf-input][data-cf-column-key="password"],
      input[data-cf-input][data-cf-column-key="password_confirmation"],
      input[data-cf-input][name="password"],
      input[data-cf-input][name="password_confirmation"]
    `);

    inputs.forEach((input) => {
      if (input.getAttribute(DONE) === '1') return;

      // wrapper（Heliumの構造）
      const field = input.closest('.cf-field') || input.parentElement;
      if (!field) return;

      // 初期は隠す
      input.type = 'password';
      input.autocomplete = input.autocomplete || 'new-password';

      // 位置調整
      field.style.position = field.style.position || 'relative';
      input.style.paddingRight = '40px';

      // ボタン作成
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'password-toggle';
      // btn.setAttribute('aria-label', 'パスワード表示切替');
      const key = input.getAttribute('data-cf-column-key') || input.name || '';
      const isConfirm = key === 'password_confirmation';
      btn.setAttribute('aria-label', isConfirm ? 'パスワード再入力の表示切替' : 'パスワード表示切替');

      // アイコン
      btn.innerHTML = `
        <span class="icon-eye" style="display:none">${ICON_EYE}</span>
        <span class="icon-eye-off">${ICON_EYE_OFF}</span>
      `;

      // SVGサイズ
      btn.querySelectorAll('svg').forEach((svg) => {
        svg.style.width = '16px';
        svg.style.height = '16px';
        svg.style.display = 'block';
      });

      // CSS
      btn.style.position = 'absolute';
      btn.style.right = '10px';
      btn.style.top = '50%';
      btn.style.transform = 'translateY(-50%)';
      btn.style.background = 'none';
      btn.style.border = 'none';
      btn.style.cursor = 'pointer';
      btn.style.zIndex = '2';
      btn.style.lineHeight = '1';
      btn.style.padding = '0';

      const eye = btn.querySelector('.icon-eye');
      const eyeOff = btn.querySelector('.icon-eye-off');

      btn.addEventListener('click', function () {
        const show = input.type === 'password';
        input.type = show ? 'text' : 'password';

        // アイコン切替
        eye.style.display = show ? 'block' : 'none';
        eyeOff.style.display = show ? 'none' : 'block';

        input.focus({ preventScroll: true });
      });

      field.appendChild(btn);
      input.setAttribute(DONE, '1');
    });
  }

  // 初回
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupHeliumPasswordField());
  } else {
    setupHeliumPasswordField();
  }

  // Heliumが後から描画・再描画する対策
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        setupHeliumPasswordField(node);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();


// パスワードリセットページのパスワード表示／非表示 
(function () {
  const DONE = 'data-reset-pw-toggle-ready';

  // （表示）アイコン
  const ICON_EYE = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" focusable="false">
      <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
    </svg>
  `;

  // （非表示）アイコン
  const ICON_EYE_OFF = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" focusable="false">
      <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
    </svg>
  `;

  function setupResetPasswordToggles() {
    const form = document.querySelector('form#reset_customer_password');
    if (!form) return;

    const inputs = form.querySelectorAll(
      'input[type="password"][name="customer[password]"],' +
      'input[type="password"][name="customer[password_confirmation]"]'
    );

    inputs.forEach((input) => {
      if (input.getAttribute(DONE) === '1') return;

      const wrapper = input.closest('.form__input-wrapper');
      if (!wrapper) return;

      // 右余白
      input.style.paddingRight = '40px';

      // wrapperを基準に配置
      wrapper.style.position = wrapper.style.position || 'relative';

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'reset-password-toggle'; // ← Helium/ログインと衝突させない
      const isConfirm = input.name.includes('password_confirmation');
      btn.setAttribute('aria-label', isConfirm ? 'パスワード再入力の表示切替' : 'パスワード表示切替');

      btn.innerHTML = `
        <span class="icon-eye" style="display:none">${ICON_EYE}</span>
        <span class="icon-eye-off">${ICON_EYE_OFF}</span>
      `;

      btn.querySelectorAll('svg').forEach((svg) => {
        svg.style.width = '16px';
        svg.style.height = '16px';
        svg.style.display = 'block';
      });

      // 位置
      btn.style.position = 'absolute';
      btn.style.right = '10px';
      btn.style.top = '50%';
      btn.style.transform = 'translateY(-50%)';
      btn.style.background = 'none';
      btn.style.border = 'none';
      btn.style.padding = '0';
      btn.style.lineHeight = '1';
      btn.style.cursor = 'pointer';
      btn.style.zIndex = '2';

      const eye = btn.querySelector('.icon-eye');
      const eyeOff = btn.querySelector('.icon-eye-off');

      btn.addEventListener('click', () => {
        const show = input.type === 'password';
        input.type = show ? 'text' : 'password';
        eye.style.display = show ? 'block' : 'none';
        eyeOff.style.display = show ? 'none' : 'block';
        input.focus({ preventScroll: true });
      });

      wrapper.appendChild(btn);
      input.setAttribute(DONE, '1');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupResetPasswordToggles);
  } else {
    setupResetPasswordToggles();
  }
})();


// パスワード再入力項目の「Must not be blank」メッセージを日本語に変更
(function () {
  const TARGET_KEY = 'password_confirmation';
  const FROM = 'Must not be blank';
  const TO = '入力必須です';

  function replace() {
    document
      .querySelectorAll(`.cf-field input[data-cf-column-key="${TARGET_KEY}"]`)
      .forEach((input) => {
        const field = input.closest('.cf-field');
        if (!field) return;

        field.querySelectorAll('.cf-field-errors span[role="alert"]').forEach((span) => {
          if (span.textContent.trim() === FROM) {
            span.textContent = TO;
          }
        });
      });
  }

  replace();

  const mo = new MutationObserver(replace);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();





// Omni Hub 店舗並び替え・注意書き追加
function customizeOmniHubStock() {
  const stockWrap = document.querySelector('#omni-hub-stock');
  if (!stockWrap) return;

  const table = stockWrap.querySelector('table');
  if (!table) return;

  // すでに処理済みの場合は注意書きだけ確認
  if (stockWrap.dataset.customized === 'true') {
    addOmniStockNote(stockWrap, table);
    return;
  }

  stockWrap.dataset.customized = 'true';

  const storeOrder = [
    { keywords: ['渋谷', 'スクランブルスクエア'] },
    { keywords: ['原宿', 'harajuku'] },
    { keywords: ['京王百貨店新宿', '京王', '新宿'] },
    { keywords: ['二子玉川'] },
    { keywords: ['池袋'] },
    { keywords: ['みなとみらい', 'colette', 'コレットマーレ'] },
    { keywords: ['ゲートタワーモール', 'タカシマヤ'] },
    { keywords: ['ルクア大阪', 'ルクア'] },
    { keywords: ['西宮', 'ガーデンズ'] },
    { keywords: ['onefukuoka', 'onefukuokabldg', 'fukuokabldg', '福岡'] },
    { keywords: ['南町田', 'グランベリーパーク'] },
    { keywords: ['酒々井'] },
    { keywords: ['多摩南大沢'] },
    { keywords: ['越谷', 'レイクタウン'] },
    { keywords: ['岡崎'] },
    { keywords: ['御殿場'] }
  ];

  const rows = Array.from(table.querySelectorAll('tr'));

  const stockData = rows.map(row => {
    const rawName = row.querySelector('th')?.textContent.trim();
    const status = row.querySelector('td')?.textContent.trim();

    return {
      originalName: rawName,
      status: status
    };
  }).filter(item => item.originalName);

  table.innerHTML = '';

  storeOrder.forEach(store => {
    const matchedStore = stockData.find(item => {
      const normalizedName = normalizeOmniText(item.originalName);

      return store.keywords.some(keyword => {
        return normalizedName.includes(normalizeOmniText(keyword));
      });
    });

    if (!matchedStore) return;

    const tr = document.createElement('tr');

    const th = document.createElement('th');
    th.textContent = matchedStore.originalName;

    const td = document.createElement('td');
    td.textContent = matchedStore.status;

    tr.appendChild(th);
    tr.appendChild(td);
    table.appendChild(tr);
  });

  addOmniStockNote(stockWrap, table);
}

// 半角・全角、スペース差を吸収
function normalizeOmniText(text) {
  return text
    .normalize('NFKC')
    .replace(/\s+/g, '')
    .toLowerCase();
}

// 注意書き追加・既存注釈削除
function addOmniStockNote(stockWrap, table) {
  const innerWrap = table.closest('div') || stockWrap;

  // 既存のOmni Hub注釈を非表示
  const existingNotes = stockWrap.querySelectorAll('span');

  existingNotes.forEach(span => {
    if (span.textContent.includes('在庫状況は最新のものではありません')) {
      span.style.display = 'none';
    }
  });

  // すでに追加済みなら何もしない
  if (stockWrap.querySelector('.c_omni-stock-note')) return;

  const note = document.createElement('div');
  note.className = 'c_omni-stock-note';

  note.innerHTML = `
    <p>
      ※在庫ありの表示でも在庫切れの場合がございます。<br>
      特にセール対象商品、及びセール開催中は在庫状況の変化が早いため、ご注意ください。<br>
      ※セール開催期間により、店舗と販売価格が異なる場合がございます。詳しくは、ご利用店舗に直接お問い合わせください。<br>
      ※SHOP LIST ショップリストは<a href="https://merrell.jp/pages/shoplist">こちら</a>をご参照ください。
    </p>
  `;

  innerWrap.appendChild(note);
}

document.addEventListener('DOMContentLoaded', () => {
  customizeOmniHubStock();

  const observer = new MutationObserver(() => {
    customizeOmniHubStock();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// ギフトカタログ対応-202607 START
// ギフトカタログ商品カード：カラーバリエーションのサムネイルhoverでメイン画像をプレビュー
(function () {
  function getPreviewImage(swatch) {
    var wrapper = swatch.closest('.card-wrapper');
    return wrapper ? wrapper.querySelector('.card__colorVariantPreviewImg') : null;
  }

  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest && event.target.closest('.card__colorVariant');
    if (!swatch || swatch.contains(event.relatedTarget)) return;

    var previewSrc = swatch.getAttribute('data-preview-src');
    var previewImg = getPreviewImage(swatch);
    if (!previewSrc || !previewImg) return;

    previewImg.src = previewSrc;
    previewImg.style.display = 'block';
  });

  document.addEventListener('mouseout', function (event) {
    var swatch = event.target.closest && event.target.closest('.card__colorVariant');
    if (!swatch || swatch.contains(event.relatedTarget)) return;

    var previewImg = getPreviewImage(swatch);
    if (!previewImg) return;

    previewImg.style.display = 'none';
  });
})();

// カラー名チップ：先頭の半角英数字部分だけを表示（カタカナ表記以降は除去）
(function () {
  function trimToLeadingAscii(text) {
    var match = text.match(/^[\x00-\x7F]*/);
    return match ? match[0].trim() : '';
  }

  function applyColorNameTrim(root) {
    (root || document).querySelectorAll('.card__colorVariant .tooltip:not([data-trimmed])').forEach(function (el) {
      el.textContent = trimToLeadingAscii(el.textContent);
      el.setAttribute('data-trimmed', '1');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyColorNameTrim();
    });
  } else {
    applyColorNameTrim();
  }

  var colorNameObserver = new MutationObserver(function () {
    applyColorNameTrim();
  });
  colorNameObserver.observe(document.body, { childList: true, subtree: true });
})();

// カートページ：カタログナンバー入力欄をカート属性として保存
(function () {
  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('#cart-catalog-number');
    if (!input) return;

    var cartUrl = (window.routes && window.routes.cartUrl) ? window.routes.cartUrl : '/cart';

    fetch(cartUrl + '/update.js', {
      body: JSON.stringify({ attributes: { 'カタログNo': input.value } }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
  });
})();
// ギフトカタログ対応-202607 END